import * as _utils from './_utils';

const prd: () => Env = () => {
  const envcode: Envcode = 'prd';

  return {
    NAME: '本番環境',
    COGNITO_REGION: 'us-west-2',
    COGNITO_USER_POOL_ID: 'us-west-2_9DXMoEVZJ',
    COGNITO_CLIENT_ID: '3l8mg80v4181gkpq0jv6jv4ab9',
    COGNITO_REDIRECT_URI: 'https://anpichecker.com/signin',
    COGNITO_DOMAIN: 'https://tf-an-prd.auth.us-west-2.amazoncognito.com',
    API_ENDPOINT: 'https://api.anpichecker.com/prd',
    ENVCODE: envcode,
    TITLE: _utils.getName(envcode),
    STRIPE_PK: 'pk_live_VOJkq9QzG9p1mtNWjWAqwCv000oJ8U8mRM',
    RECAPTCHA_SITE_KEY: '6LeA_uwUAAAAAJRa8iDis4Ql9wjrZzzO_uxyY7ED',
  };
};

export default prd();
